import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const NotificationSettingSave = createAsyncThunk(
  "NotificationSettingSave",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.NOTIFICATION_SETTING.SAVE,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

export const NotificationSettingGetList = createAsyncThunk(
  "NotificationSettingGetList",
  async (data = {}, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.NOTIFICATION_SETTING.GET_LIST,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  NotificationSettingSaveData: {
    data: null,
    error: null,
  },
  NotificationSettingGetListData: {
    data: null,
    error: null,
  },
};

const CartSlice = createSlice({
  name: "NOTIFICATIONSETTING",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(NotificationSettingSave.fulfilled, (state, action) => {
        state.NotificationSettingSaveData.data = action.payload;
      })
      .addCase(NotificationSettingSave.rejected, (state, action) => {
        state.NotificationSettingSaveData.error = action.error.message;
      })
      .addCase(NotificationSettingGetList.fulfilled, (state, action) => {
        state.NotificationSettingGetListData.data = action.payload;
      })
      .addCase(NotificationSettingGetList.rejected, (state, action) => {
        state.NotificationSettingGetListData.error = action.error.message;
      });
  },
});

export default CartSlice.reducer;
